import React from 'react'

import { WithNavigation } from 'data/wrappers/WithNavigationComponent'

export const withNavigation = (Child) => (props) => (
    <WithNavigation>
        {(navigationProps) => <Child {...navigationProps} {...props} />}
    </WithNavigation>
)
